import React, { useState } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link, useNavigate } from "react-router-dom";
import { DEFAULT_SESSION, SESSION_OPTIONS } from "../../../constants/sessions";

const AdmissionForm = () => {
  const navigate = new useNavigate();
  const [formData, setFormData] = useState({
    student_name: "",
    dob: "",
    gender: "",
    aadhar_number: "",
    student_class: "",
    admission_number: "",
    date_of_admission: "",
    session: DEFAULT_SESSION,
    category: "",
    blood_group: "",
    mother_tongue: "",
    nationality: "",
    father_name: "",
    contact_number_father: "",
    father_occupation: "",
    mother_name: "",
    contact_number_mother: "",
    mother_occupation: "",
    email: "",
    address: "",
    police_station: "",
    post_office: "",
    district: "",
    state: "JHARKHAND",
    pincode: "",
    expelled: "",
    siblings_in_school: "",
    siblings_name_class: "",
    admission_fees_paid: false,
    transportation: "",
    declaration: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (
      name === "expelled" ||
      name === "siblings_in_school" ||
      name === "transportation"
    ) {
      setFormData({
        ...formData,
        [name]: value === "true", // Convert "true"/"false" to boolean
      });
    } else {
      setFormData({
        ...formData,
        [name]: type === "checkbox" ? checked : value.toUpperCase(),
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/admissions/form`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 201) {
        toast.success("Student added successfully!");

        setTimeout(() => {
          navigate(`/erp/admissions/list`);
        }, 2000);
      } else {
        toast.error("Failed to add student. Please try again.");
      }
    } catch (error) {
      toast.error("An error occurred. Please check your input and try again.");
    }
  };

  const categories = ["GEN", "OBC", "SC", "ST"];
  const classes = [
    "PRE-NURSERY",
    "NURSERY",
    "LKG",
    "UKG",
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
  ];

  return (
    <>
      <div className="container mt-5 bg-white rounded p-5">
        <div className="row">
          <div className="col-12 d-flex justify-content-between align-items-center">
            <Link to="/erp/admissions" className="btn btn-secondary mb-3">
              &#8592; Back to Admissions
            </Link>
            <h3 className="text-center text-success d-flex justify-content-between align-items-start ">
              Add New Student
            </h3>
          </div>
        </div>
        <form onSubmit={handleSubmit}>
          {/* Row 1 */}
          <div className="row g-3 mt-2">
            <h4 className="mt-3">Student Details</h4>
            <div className="col-md-4">
              <label className="form-label">Name of Student *</label>
              <input
                type="text"
                className="form-control"
                name="student_name"
                value={formData.student_name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="col-md-4">
              <label className="form-label">Class for Admission *</label>
              <select
                className="form-control"
                name="student_class"
                value={formData.student_class}
                onChange={handleChange}
                required
              >
                <option value="">Select Class</option>
                {classes.map((cls, index) => (
                  <option key={index} value={cls}>
                    {typeof cls === "number" ? `Class ${cls}` : cls}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-4">
              <label className="form-label">Date of Birth *</label>
              <input
                type="date"
                className="form-control"
                name="dob"
                value={formData.dob}
                onChange={handleChange}
                required
              />
            </div>
          </div>
          {/* Row 2 */}
          <div className="row g-3 mt-3">
            <div className="col-md-4">
              <label className="form-label">Gender *</label>
              <select
                className="form-control"
                name="gender"
                value={formData.gender === null ? "" : formData.gender} // Default to empty string if null
                onChange={handleChange}
                required
              >
                <option value="">Select</option>
                <option value="MALE">Male</option>
                <option value="FEMALE">Female</option>
              </select>
            </div>
            <div className="col-md-4">
              <label className="form-label">Aadhar Number</label>
              <input
                type="number"
                className="form-control"
                name="aadhar_number"
                value={formData.aadhar_number}
                maxLength={16}
                onChange={handleChange}
              />
            </div>

            <div className="col-md-4">
              <label className="form-label">Session *</label>
              <select
                className="form-control"
                name="session"
                value={formData.session}
                onChange={handleChange}
                required
              >
                {SESSION_OPTIONS.map((session) => (
                  <option key={session} value={session}>
                    {session}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Row 3 */}
          <div className="row g-3 mt-3">
            <div className="col-md-4">
              <label className="form-label">Admission Number *</label>
              <input
                type="text"
                className="form-control"
                name="admission_number"
                value={formData.admission_number}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">Date of Admission *</label>
              <input
                type="date"
                className="form-control"
                name="date_of_admission"
                value={formData.date_of_admission}
                onChange={handleChange}
                required
              />
            </div>

            <div className="col-md-4">
              <label className="form-label">Category *</label>
              <select
                className="form-control"
                name="category"
                value={formData.category}
                onChange={handleChange}
                required
              >
                <option value="">Select Category</option>
                {categories.map((category, index) => (
                  <option key={index} value={category}>
                    {category}
                  </option>
                ))}
              </select>
            </div>
          </div>
          {/* Row 4 */}
          <div className="row g-3 mt-3">
            <div className="col-md-4">
              <label className="form-label">Blood Group</label>
              <input
                type="text"
                className="form-control"
                name="blood_group"
                value={formData.blood_group}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">Mother Tongue *</label>
              <input
                type="text"
                className="form-control"
                name="mother_tongue"
                value={formData.mother_tongue}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">Nationality *</label>
              <input
                type="text"
                className="form-control"
                name="nationality"
                value={formData.nationality}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          {/* Row 5 */}
          <div className="row g-3 mt-3">
            <h4 className="mt-3">Parent's Details</h4>
            <div className="col-md-4">
              <label className="form-label">Father&apos;s Name *</label>
              <input
                type="text"
                className="form-control"
                name="father_name"
                value={formData.father_name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">
                Father&apos;s Contact Number *
              </label>
              <input
                type="number"
                className="form-control"
                name="contact_number_father"
                value={formData.contact_number_father}
                onChange={handleChange}
                maxLength={10}
                required
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">Father's Occupation *</label>
              <input
                type="text"
                className="form-control"
                name="father_occupation"
                value={formData.father_occupation}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          {/* Row 5 */}
          <div className="row g-3 mt-3">
            <div className="col-md-4">
              <label className="form-label">Mother&apos;s Name *</label>
              <input
                type="text"
                className="form-control"
                name="mother_name"
                value={formData.mother_name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="col-md-4">
              <label className="form-label">Mother&apos;s Contact Number</label>
              <input
                type="number"
                className="form-control"
                name="contact_number_mother"
                value={formData.contact_number_mother}
                onChange={handleChange}
                maxLength={10}
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">Mother's Occupation *</label>
              <input
                type="text"
                className="form-control"
                name="mother_occupation"
                value={formData.mother_occupation}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          {/* Row 6 */}
          <div className="row g-3 mt-3">
            <div className="col-md-4">
              <label className="form-label">Email Address</label>
              <input
                type="email"
                className="form-control"
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
            </div>
          </div>

          {/* Row 7 */}
          <div className="row g-3 mt-3">
            <h4 className="mt-3">Address and Other Details</h4>
            <div className="col-md-4">
              <label className="form-label">Address *</label>
              <input
                type="text"
                className="form-control"
                name="address"
                value={formData.address}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">Police Station *</label>
              <input
                type="text"
                className="form-control"
                name="police_station"
                value={formData.police_station}
                onChange={handleChange}
                required
              />
            </div>

            <div className="col-md-4">
              <label className="form-label">Post Office *</label>
              <input
                type="text"
                className="form-control"
                name="post_office"
                value={formData.post_office}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          {/* Row 6 */}
          <div className="row g-3 mt-3">
            <div className="col-md-4">
              <label className="form-label">District *</label>
              <input
                type="text"
                className="form-control"
                name="district"
                value={formData.district}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">State *</label>
              <input
                type="text"
                className="form-control"
                name="state"
                value={formData.state}
                onChange={handleChange}
                required
                disabled
              />
            </div>

            <div className="col-md-4">
              <label className="form-label">Pin Code *</label>
              <input
                type="number"
                className="form-control"
                name="pincode"
                value={formData.pincode}
                onChange={handleChange}
                required
                maxLength={6}
              />
            </div>
          </div>
          {/* Row 8 */}
          <div className="row g-3 mt-3">
            <div className="col-md-4">
              <label className="form-label">
                Whether Expelled in Previous School ? *
              </label>
              <select
                className="form-control"
                name="expelled"
                value={formData.expelled === null ? "" : formData.expelled} // Default to empty string if null
                onChange={handleChange}
                required
              >
                <option value="">Select</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>
            <div className="col-md-4">
              <label className="form-label">
                Whethter Transportation Opted ? *
              </label>
              <select
                className="form-control"
                name="transportation"
                value={
                  formData.transportation === null
                    ? ""
                    : formData.transportation
                } // Default to empty string if null
                onChange={handleChange}
                required
              >
                <option value="">Select</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>

            <div className="col-md-4">
              <label className="form-label">
                Any Siblings Studying in School *
              </label>
              <select
                className="form-control"
                name="siblings_in_school"
                value={
                  formData.siblings_in_school === null
                    ? ""
                    : formData.siblings_in_school
                } // Default to empty string if null
                onChange={handleChange}
                required
              >
                <option value="">Select</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>
          </div>
          {/* Conditional rendering for Relative Name */}
          <div className="row g-3 mt-3">
            {formData.siblings_in_school && (
              <div className="col-md-4">
                <label className="form-label">
                  Siblings's Name and Class *
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="siblings_name_class"
                  value={formData.siblings_name_class}
                  onChange={handleChange}
                  required
                />
              </div>
            )}
          </div>
          {/* Declaration Checkbox */}
          <div className="mt-3">
            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                name="declaration"
                checked={formData.declaration}
                onChange={handleChange}
                required
              />
              <label className="form-check-label">
                I declare that all the information is correct.
              </label>
            </div>
          </div>

          {/* Submit Button */}
          <div className="d-grid gap-2 d-flex justify-content-center mt-4">
            <button
              type="submit"
              className="btn btn-success"
              disabled={!formData.declaration}
            >
              Add Student
            </button>
          </div>
        </form>

        <ToastContainer />
      </div>
    </>
  );
};

export default AdmissionForm;
